// extracted by mini-css-extract-plugin
export default {"introSection":"WatchPage_introSection__V+X4u"};